import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { Observable, startWith, map } from 'rxjs';
import { Logger } from 'pr1-ui-components';
import { MatSelectionList } from '@angular/material/list';

const log = new Logger('StoreSelectorDialogComponent');

 interface Store {
  id: string;
  StoreName: string;
  selected?: boolean;
}

@Component({
  selector: 'app-store-selector-dialog',
  templateUrl: './store-selector-dialog.component.html',
  styleUrls: ['./store-selector-dialog.component.scss']
})
export class StoreSelectorDialogComponent {
  @ViewChild('storeList') storeList!: MatSelectionList;

  searchText = '';
  stores: Store[];

  constructor(
    public dialogRef: MatDialogRef<StoreSelectorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { stores: Store[] }
  ) {
    this.stores = data.stores;
  }

  filteredStores(): Store[] {
    return this.stores.filter(s =>
      s.StoreName.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  submitSelection(): void {
  if (!this.storeList) {
    this.close([]);
    return;
  }
  const selectedStores = this.storeList.selectedOptions.selected.map(o => o.value as Store);
  this.close(selectedStores);
}

hasSelection(): boolean {
  return this.storeList?.selectedOptions?.selected?.length > 0;
}


  close(selected: Store[]): void {
    this.dialogRef.close(selected);
  }
}
